// Chakra imports
import {
  Flex,
  useColorModeValue,
} from "@chakra-ui/react";
import React, { useContext } from "react";
import WelcomeUsers from "./components/WelcomeUsers";
import ServiceDown from "./components/ServiceDown";
import UserSearchInput from "./components/UserSearchInput";
import ChatVersion from "./components/ChatVersion";
import TermsPrivacy from "./components/TermsPrivacy";
// import LangChain from "./components/LangChain";

export default function Dashboard() {
  const iconBoxInside = useColorModeValue("white", "white");
  const bgColor = useColorModeValue("white", "gray.700");
  const textColor = useColorModeValue("gray.700", "white");
  const bgIcons = useColorModeValue("teal.200", "rgba(255, 255, 255, 0.5)");
  const titleColor = useColorModeValue("teal.300", "teal.200");
  const isServiceDown = false;

  return (
    <Flex 
      flexDirection='column' 
      pt={{ base: "120px", md: "50px" }} 
      alignItems="center"
      >
      {/* <ChatVersion/> */}
      {isServiceDown ? <ServiceDown /> : <WelcomeUsers />}

      <UserSearchInput/>
      {/* <LangChain/> */}
      <TermsPrivacy/>
    </Flex>
  );
}
